( function () {
    'use strict';
    ( function ( $ ) {
        $('.investor-slider').slick({
            slideToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            infinite: false,
            arrows: true,
            dots: false,
            fade: false,
            rows: 0,
            variableWidth: true,
            prevArrow: $('.inv-prev'),
            nextArrow: $('.inv-next'),
            mobileFirst:true,
            centerMode:false,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 6,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                }                
              ]
        });

        $('#collapse-slick').on('click',function(e){
            e.preventDefault();
            if($(this).hasClass('collapsed')){
                $(this).text($(this).data('ntext'));
                $(this).removeClass('collapsed');
                $('.investor-slider-wrap').animate({maxHeight: "210px"},300,function(){                  
                  $('.inv-arrows').removeClass('disabled');
                  $('.investor-slider').addClass('not-collapsed');
                  $('.investor-slider').removeClass('container');                
                  $('.investor-slider').slick({
                    slideToShow: 4,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    fade: false,
                    rows: 0,
                    variableWidth: true,
                    prevArrow: $('.inv-prev'),
                    nextArrow: $('.inv-next'),
                    mobileFirst:true,
                    centerMode:false,
                    responsive: [
                        {
                          breakpoint: 1024,
                          settings: {
                            slidesToShow: 6,
                          }
                        },
                        {
                          breakpoint: 600,
                          settings: {
                            slidesToShow: 3,
                          }
                        },
                        {
                          breakpoint: 480,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                          }
                        }                
                      ]
                  });
                });
            }
            else{
                $(this).text($(this).data('ctext'));
                $(this).addClass('collapsed');
                $('.investor-slider').removeClass('not-collapsed');
                $('.investor-slider').addClass('container');
                $('.investor-slider').slick('unslick');
                $('.inv-arrows').addClass('disabled');
                $('.investor-slider-wrap').animate({maxHeight: "10000px"},500);
            }            
        });
    } )( jQuery );
} )();